<template>
  <v-chip
    v-if="item.showText"
    :color="color"
    :small="item.small"
    :outlined="item.outlined"
    class="construct-visual-badge"
  >
    {{ truncateText(text) }}
  </v-chip>
  <v-icon v-else :color="color" :small="item.small" title="Pastille">mdi-circle</v-icon>
</template>

<script>
import displayMixin from './mixin'

export default {
  name: 'ConstructVisualDisplayBadge',
  mixins: [displayMixin],
  computed: {
    text() { return this.resolveValue(this.item.text, this.item.textSource) },
    color() { return this.resolveValue(this.item.color, this.item.colorSource, 'primary') },
  },

methods: {
  truncateText(value) {
    if (!value) return ''
    const limit = this.item.limitCaracter || 1000
    return value.length > limit 
      ? value.substring(0, limit) + '...'
      : value
  }
}
}
</script>

<style scoped>
.construct-visual-badge { max-width: 100%; }
</style>
